export default __webpack_public_path__ + "static/media/q1_step1_2.2224e02a.png";